import formValidation from 'formvalidation/es6/core/Core';
import Bootstrap3 from 'formvalidation/es6/plugins/Bootstrap3';
import DefaultSubmit from 'formvalidation/es6/plugins/DefaultSubmit';
import SubmitButton from 'formvalidation/es6/plugins/SubmitButton';
import Declarative from 'formvalidation/es6/plugins/Declarative';
import Trigger from 'formvalidation/es6/plugins/Trigger';
import Recaptcha from 'formvalidation/es6/plugins/Recaptcha';
import Aria from 'formvalidation/es6/plugins/Aria';
import 'es6-shim';

$(() => {
    $('.scene').parallax({
        originY: 1,
        scalarY: 20,
    });
});

$(document).ready(($) => {
    if (document.querySelector('.top form') && document.querySelector('.bottom form')) {
        const topFormCaptcha = document.querySelector('.top form .paywall_captcha_container');
        const bottomFormCaptcha = document.querySelector('.bottom form .paywall_captcha_container');
        formValidation(document.querySelector('.top form'), {
            plugins: {
                aria: new Aria(),
                trigger: new Trigger(),
                bootstrap3: new Bootstrap3(),
                defaultSubmit: new DefaultSubmit(),
                submitButton: new SubmitButton(),
                declarative: new Declarative({
                    html5Input: true,
                }),
                recaptcha: new Recaptcha({
                    element: topFormCaptcha,
                    siteKey: process.env.INVISIBLE_RECAPTCHA_SITE_KEY,
                    size: 'invisible',
                    message: JSON.parse(document.querySelector('.top form .json_translations').innerHTML).reCaptchaErrorMessage,
                }),
            },
        });
        formValidation(document.querySelector('.bottom form'), {
            plugins: {
                trigger: new Trigger(),
                bootstrap3: new Bootstrap3(),
                defaultSubmit: new DefaultSubmit(),
                submitButton: new SubmitButton(),
                declarative: new Declarative({
                    html5Input: true,
                }),
                recaptcha: new Recaptcha({
                    element: bottomFormCaptcha,
                    siteKey: process.env.INVISIBLE_RECAPTCHA_SITE_KEY,
                    size: 'invisible',
                    message: JSON.parse(document.querySelector('.bottom form .json_translations').innerHTML).reCaptchaErrorMessage,
                }),
            },
        });
    }

    $('input.form-control')
        .on('input', function () {
            const tmpval = $(this).val();
            if (tmpval === '') {
                $(this).addClass('empty');
                $(this).removeClass('not-empty');
            } else {
                $(this).addClass('not-empty');
                $(this).removeClass('empty');
            }
        })
        .trigger('input');
});
